<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <group-modal v-if="open"/>
        <v-card>
          <v-toolbar flat dense light color="grey lighten-5">
            <v-toolbar-title>Grup İşlemleri</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div class="text-left">
              <small>
                *Sayfa içinde <b>Grup güncelleme işlemi</b> için
                <b>Ad</b> sütununa tıklayabilirsiniz.
              </small>
            </div>
            <template>
              <v-spacer></v-spacer>
              <v-btn
                class="mb-2"
                @click="open = !open">
                Yeni Grup Kaydı Ekle
              </v-btn>
            </template>
            <v-flex d-flex>
              <v-text-field
                v-model="search"
                label="Grupları Filtreleyin">
              </v-text-field>
            </v-flex>
            <only-group-datatable
              :search="search">
            </only-group-datatable>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapFields } from 'vuex-map-fields';
import OnlyGroupDatatable from '../../Components/Datatables/OnlyGroupDatatable/OnlyGroupDatatable.vue';
import GroupModal from '../../Components/Modals/GroupModal.vue';

export default {
  name: 'OnlyGroup',
  components: { GroupModal, OnlyGroupDatatable },
  data: () => ({
    search: '',
  }),
  computed: {
    ...mapFields(['modal.open']),
    ...mapFields({ modalData: 'modal.data' }),
  },
};
</script>
